<template>
    <Tooltip multiline>
        <Btn
            icon="help-outline"
            icon-size="16"
            variant="basic"
            colour="anchor"
            slim
            :icon-label="tooltip"
        />
        <template #tooltip>
            <Txt size="xs">
                {{ tooltip }}
            </Txt>
        </template>
    </Tooltip>
</template>

<script>
import Txt from '@/components/form/txt';
import Btn from '@/components/utility/button';
import Tooltip from '@/components/utility/tooltip';

export default {
    name: 'TooltipHelp',
    components: { Txt, Btn, Tooltip },
    props: {
        tooltip: { type: String, required: true },
    },
};
</script>
